import React, { useState } from "react";
import { useQuery, useSelector } from "@tanstack/react-query";
import { axInst } from "../../Components/Login/Service";
import Select from "react-select";

import PvinCustomerProfile from "./PvinStatics/PvinCustomerProfile";
import SummaryDetails from "./PvinStatics/SummaryDetails";
import FleetDetails from "./PvinStatics/FleetDetails";
import TataCareCoupon from "./PvinStatics/TatacareCoupon";
import PvinFilter from "../../Components/Filters/PvinFilter";
import CustomerComplaint from "./PvinStatics/CustomerComplaint";
import FleetEdge from "./PvinStatics/FleetEdge";
import Last5Services from "./PvinStatics/Last5Services";
import ServiceSummary from "./PvinStatics/ServiceSummary";
import RenewalReminder from "./PvinStatics/RemainderServices";
import CustomerSummary from "./CustomerSummary";
import { useSelector as useReduxSelector } from "react-redux";

const getDealerFilterOptions = async (status) => {
  const res = await axInst.post("pvin/filter", {
    filter_status: status,
  });
  return res.data;
};

const Pvin = () => {
  const selectedFilter = useReduxSelector(
    (state) => state.filtersPvin.selectedFilter,
  );

  const [searchText, setSearchText] = useState("");

  // Filter dealers based on search

  const isFilterEmpty =
    !selectedFilter || Object.keys(selectedFilter).length === 0;

  // 🔹 Dealer Filter State
  const [filterType, setFilterType] = useState("Dealer_Name");
  const [dealerValue, setDealerValue] = useState("");

  // 🔹 Fetch Dealer Options
  const { data: dealerOptions = [] } = useQuery({
    queryKey: ["dealerFilter", filterType],
    queryFn: () => getDealerFilterOptions(filterType),
  });

  // 🔹 Prepare payload for summary
  const dealerFilterPayload = dealerValue
    ? filterType === "Dealer_Name"
      ? { dealer_name: [dealerValue] }
      : { Dealer_Code: [dealerValue] }
    : {};

  const dealerSelectOptions = dealerOptions.map((d) => ({
    value: d.key,
    label: d.key,
  }));

  return (
    <div className="flex flex-col flex-grow">
      {/* ================= DEALER FILTER (TOP) ================= */}

      {isFilterEmpty && (
        <div className="px-2 mt-2 flex gap-3 items-center">
          {/* Filter Type */}
          <select
            className="border p-2 rounded"
            value={filterType}
            onChange={(e) => {
              setFilterType(e.target.value);
              setDealerValue("");
            }}
          >
            <option value="Dealer_Name">Dealer Name</option>
            <option value="Dealer_Code">Dealer Code</option>
          </select>

          {/* Searchable Dropdown */}
          <div className="w-[250px]">
            <Select
              options={dealerSelectOptions}
              placeholder="Search & select dealer..."
              value={
                dealerValue ? { value: dealerValue, label: dealerValue } : null
              }
              onChange={(selected) => setDealerValue(selected?.value || "")}
              isClearable
            />
          </div>
        </div>
      )}

      {/* ================= PVIN FILTER (ALWAYS SHOW) ================= */}

      <div className="px-2 mt-2">
        <PvinFilter />
      </div>

      {/* ================= CONTENT ================= */}

      {isFilterEmpty ? (
        <CustomerSummary dealerFilterPayload={dealerFilterPayload} />
      ) : (
        <>
          <div className="px-2 mt-2">
            <PvinCustomerProfile />
          </div>

          <section className="px-2 mt-2">
            <TataCareCoupon />
          </section>

          <section className="px-2 mt-2">
            <SummaryDetails />
          </section>

          <div className="md:flex gap-2 block px-2 mt-2">
            <RenewalReminder />
            <CustomerComplaint />
            <FleetDetails />
          </div>

          <section className="px-2 mt-2">
            <ServiceSummary />
          </section>

          <section className="px-2 mt-2">
            <Last5Services />
          </section>

          <section className="px-2 mt-2">
            <FleetEdge />
          </section>
        </>
      )}
    </div>
  );
};

export default Pvin;
